import React, { useEffect, useState } from 'react';
import Loader from '../Loader/Loader';
import { AiFillDelete, AiFillEdit, AiOutlineEye } from "react-icons/ai";
import { Pagination, message, Tooltip } from "antd"
import { useNavigate } from 'react-router';
import Avtar from "../../Images/avatar.png"
import { getUsers, deleteUser } from '../../Web Apis/Apis';
import ViewUser from './ViewUser';
import EditUser from './EditUser';
import { MdNotificationsActive } from "react-icons/md";
import ViewNotifications from './ViewNotifications';
import * as XLSX from 'xlsx';
import { IoMdDownload } from "react-icons/io";

function UserManagement() {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [allUsers, setAllUsers] = useState([])
  const [action, setAction] = useState(false);
  const [selectedUser, setSelectedUser] = useState({});

  const [showUpdateModal, setShowUpdateModal] = useState(false)
  const [showViewModal, setShowViewModal] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [showNotificationModal, setShowNotificationModal] = useState(false)

  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Calculate the current items for the page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const filterUsers = allUsers?.filter((user) => {
    const query = searchQuery.toLowerCase();
    return (
      (user.firstName && user.firstName.toLowerCase().includes(query)) ||
      (user.email && user.email.toLowerCase().includes(query)) ||
      (user.lastName && user.lastName.toLowerCase().includes(query)) ||
      (user.phone && user.phone.toLowerCase().includes(query))
    )
  })

  const currentUser = filterUsers.slice(indexOfFirstItem, indexOfLastItem);

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1)
  }






  const fetchUsers = async () => {
    try {
      setLoading(true)

      const response = await getUsers()
      if (response?.data?.success) {
        // message.success(response?.data?.message)
        const reverseData = [...response?.data?.data].reverse()
        setAllUsers(reverseData)
      }
    } catch (error) {
      console.log("Admin fetch error", error.message)
      if (error.message === 'Network Error' || error.message.includes('ERR_INTERNET_DISCONNECTED')) {
        // Handle internet disconnection
        return;
      }
      // Handle specific error cases
      if (error?.response?.status === 401) {
        window.alert("Your account is logged in to another device, please login again !")
        localStorage.clear();
        window.location.href = "/login"
      }
      if (error?.response?.status === 500) {
        message.error("Server not responding")
      }
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchUsers();
  }, [action])





  const handleExportExcel = () => {
    if(!allUsers || allUsers.length === 0 ) return message.error("No data available to download")
    const filteredNotifications = allUsers.map(({ id, password
      , confirmPassword
      , profileImageUrl
      , otpTimestamp
      , active, otpType
      , role
      , signupType
      , deviceToken
      , firebaseToken
      , token
      , socialLoginId
      , socialLoginType
      , coinUpdate
      , stripeCustomerId
      , stripeSubscriptionId
      , receiveVoucherNotification
      , upcomingOccasionNotification
      , marketingCommunication
      , timestamp
      , otpVerified
      , createdAt
      , termsAndCondition
      , otp
      , ...rest }) => rest);
    const worksheet = XLSX.utils.json_to_sheet(filteredNotifications);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Users Management");
    XLSX.writeFile(workbook, "Users_Report.xlsx");
  };




  const handleUpdateModalOpen = (user) => {
    setSelectedUser(user)
    setShowUpdateModal(true)
  }

  const handleDeleteModalOpen = (user) => {
    setSelectedUser(user)
    setShowDeleteModal(true)
  }

  const handleViewModalOpen = (user) => {
    setSelectedUser(user)
    setShowViewModal(true)
  }

  const hanldeViewNotifications = (user) => {
    setSelectedUser(user.id)
    setShowNotificationModal(true)
  }


  const hanldeDelete = async () => {
    if (!selectedUser) {
      return;
    }
    try {
      setLoading(true)
      const response = await deleteUser(selectedUser)
      if (response?.data?.success) {
        message.success(response?.data?.message)
        setShowDeleteModal(false)
        setAction(!action)
      }
    } catch (error) {
      console.log("Error while delete user ...", error.message)
      message.error(error?.response?.data?.message)
    } finally {
      setLoading(false)
    }
  }


  return (
    <div className='p-4'>

      <div className="flex justify-between items-center w-full space-x-4">
        {/* Search Input Container */}


        
          <h3 className='text-3xl font-bold'>User Management</h3>

          <div className="relative flex items-center justify-end gap-2 ">

          <button onClick={handleExportExcel} className="mr-2 bg-blue-500 text-white px-2 py-2 rounded cursor-pointer flex">
          <IoMdDownload className="mr-2 mt-1 text-xl" />Export Excel</button>
        <input
          type="text"
          placeholder="Search users..."
          className="p-3 border-4 border-gray-500 rounded-md focus:outline-none"
          onChange={handleSearch} // Update the state on input change
        />

       

          </div>
        {/* <FaSearch className="absolute right-4 mr-10 text-gray-800 h-5 w-5 cursor-pointer" /> */}
        {/* Create Button */}
        {/* <button
          onClick={handleCreateModalOpen}
          className="bg-gradient-to-br from-blue-500 to-gray-500 hover:bg-blue-700 text-white font-bold py-2 px-8 rounded"
        >
          Create
        </button> */}
      </div>




      <table className='min-w-full mt-7 bg-gradient-to-br from-purple-700 to-gray-300 border border-b-4 border-black'>
        <thead>
          <th className="py-2 px-4 border-b text-center">S.No</th>
          <th className="py-2 px-4 border-b text-center">Profile Img</th>
          <th className="py-2 px-4 border-b text-center">Full Name</th>

          <th className="py-2 px-4 border-b text-center">Email</th>
          <th className="py-2 px-4 border-b text-center">Phone</th>
          <th className="py-2 px-4 border-b text-center">Phone Verified</th>
          <th className="py-2 px-4 border-b text-center">Coin Balance</th>
          <th className="py-2 px-4 border-b text-center">Subscription Plan</th>
          <th className="py-2 px-4 border-b text-center">Marketing & Comm</th>
          <th className="py-2 px-4 border-b text-center">Status</th>
          <th className="py-2 px-4 border-b text-center">Actions</th>
        </thead>
        <tbody>
          {currentUser?.length > 0 ? (
            currentUser?.map((user, index) => (
              <tr key={user.id}
                className={`hover:bg-gray-200 text-center transition duration-200 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-300'}`}
              >
                <td className='py-2 px-4 border-b'>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                <td className="py-2 px-4 border-b flex justify-center">
                  <img
                    src={user?.profileImageUrl || Avtar}
                    alt="user"
                    className="w-30 h-30 object-cover border border-gray-700"
                    style={{ height: "50px", width: "50px", borderRadius: "50%" }}
                  />
                </td>
                <td className="py-2 px-4 border-b">{user.firstName} {user.lastName}</td>

                <td className="py-2 px-4 border-b">{user.email}</td>
                <td className="py-2 px-4 border-b">{user.phone}</td>
                <td className={`py-2 px-4 border-b font-bold ${user.mobileVerified ? 'text-green-600' : 'text-red-500'}`}>{user.mobileVerified ? 'Verified' : 'Not Verified'}</td>

                <td className="py-2 px-4 border-b">{user.coins}</td>
                
              <td className="py-2 px-4 border-b">{user.subscriptionPlan}</td>

                <td className={`py-2 px-4 border-b font-bold ${user.marketingCommunication ? 'text-green-600' : 'text-red-500'}`}>{user.marketingCommunication ? "ON" : "OFF"}</td>
                <td className="py-2 px-4 border-b">
                  <span className={`py-0.5 px-2 text-[20px] font-medium w-fit ${user.active ? "text-green-600" : "text-red-500"}`}>
                    {user.active ? "Active" : "Inactive"}
                  </span>
                </td>

                <td className="py-2 px-4 border-b">
                  <div className="flex flex-row justify-center">
                    <Tooltip title="View Notifications">
                      <button
                        onClick={() => hanldeViewNotifications(user)}
                        className="text-blue-500 hover:text-blue-700 flex items-center"
                      >
                        <MdNotificationsActive className="mr-1 text-xl" />
                      </button>
                    </Tooltip>
                    <button
                      onClick={() => handleViewModalOpen(user)}
                      className="text-blue-500 hover:text-blue-700 flex items-center"
                    >
                      <AiOutlineEye className="mr-1 text-xl" />
                    </button>
                    <button
                      onClick={() => handleUpdateModalOpen(user)}
                      className="mr-2 text-blue-500 hover:text-blue-700 flex items-center"
                    >
                      <AiFillEdit className="mr-1 text-xl" />
                    </button>
                    <button
                      onClick={() => handleDeleteModalOpen(user)}
                      className="text-red-500 hover:text-red-700 flex items-center"
                    >
                      <AiFillDelete className="mr-1 text-xl" />
                    </button>
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7" className=' px-4 py-4 border-b text-center font-bold'>No user data found</td>
            </tr>
          )}
        </tbody>
      </table>
      {loading && <Loader />}

      <div className="mt-4 flex justify-end">
        <Pagination
          current={currentPage}
          total={allUsers.length}
          pageSize={itemsPerPage}
          onChange={handlePageChange}
          showSizeChanger={false}
        />
      </div>

      {showViewModal && (
        <ViewUser
          showViewModal={showViewModal}
          setShowViewModal={setShowViewModal}
          selectedUser={selectedUser}
        />
      )}

      {showUpdateModal && (
        <EditUser
          showUpdateModal={showUpdateModal}
          setShowUpdateModal={setShowUpdateModal}
          selectedUser={selectedUser}
          action={action}
          setAction={setAction}
        />
      )}

      {showNotificationModal && (
        <ViewNotifications
          selectedUser={selectedUser}
          showNotificationModal={showNotificationModal}
          setShowNotificationModal={setShowNotificationModal}
        />
      )}

      {showDeleteModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-gradient-to-br from-purple-900 to-purple-500 p-8 rounded-lg shadow-lg w-full max-w-md">
            <h3 className="text-3xl font-bold mb-4 text-start text-white">Confirm Delete</h3>
            <p className="mb-4 text-start text-white">Are you sure you want to delete this user ? </p>
            <div className="flex justify-end gap-4">
              <button onClick={() => { setShowDeleteModal(false) }} className="bg-gray-300 text-black py-3 px-8 rounded-md hover:bg-gray-400 transition duration-200">
                Cancel
              </button>
              <button onClick={hanldeDelete} className="bg-red-600 text-white py-3 px-8 rounded-md mr-2 hover:bg-red-700 transition duration-200">
                Delete
              </button>
            </div>
          </div>
        </div>
      )
      }

    </div>
  )
}


export default UserManagement